import * as swcHelpers from '@swc/helpers';
import { Actions } from '@grandvisionhq/auth';
import { CHANGE_FORM_VALUE } from '../actions.js';
import { isProfileForm } from './state.js';
import { TOGGLE_FORM_EDIT_MODE } from './actions.js';

const initialState = {
    forms: {}
};
function profileReducer(state = initialState, action) {
    switch(action.type){
        case Actions.UserDataActions.UPDATE_USER_DATA_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                forms: swcHelpers.objectSpread({}, state.forms, {
                    [action.payload.formName]: swcHelpers.objectSpread({}, state.forms[action.payload.formName], {
                        inEditMode: false
                    })
                })
            });
        case CHANGE_FORM_VALUE:
            if (!isProfileForm(action.payload.form.formName)) {
                return state;
            }
            return swcHelpers.objectSpread({}, state, {
                forms: swcHelpers.objectSpread({}, state.forms, {
                    [action.payload.form.formName]: swcHelpers.objectSpread({}, state.forms[action.payload.form.formName], {
                        state: action.payload.form
                    })
                })
            });
        case TOGGLE_FORM_EDIT_MODE:
            const initialFormState = state.forms[action.payload.formName];
            const internalState = initialFormState ? initialFormState.state : {
                formState: {},
                formValid: false,
                formName: action.payload.formName
            };
            const internalFormState = {
                state: internalState,
                inEditMode: action.payload.inEditMode
            };
            return swcHelpers.objectSpread({}, state, {
                forms: swcHelpers.objectSpread({}, state.forms, {
                    [action.payload.formName]: internalFormState
                })
            });
        default:
            return state;
    }
}

export { initialState, profileReducer };
//# sourceMappingURL=reducer.js.map
